import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.SLATE,
  label: 'slate',
  tokens: {
    'primary-button': [
      'tw-bg-slate-600',
      'hover:tw-bg-slate-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-slate-200',
      'tw-bg-slate-100',
      'tw-text-slate-950',
      'hover:tw-bg-slate-300',
      'active:tw-bg-slate-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-slate-600',
      'tw-text-slate-900',
      'hover:tw-bg-slate-50',
      'active:tw-bg-slate-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],
    'primary-text': ['tw-text-slate-700'],
    'header-nav': ['!tw-bg-slate-800'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-slate-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-slate-600'],
    'primary-icon': ['tw-fill-slate-500', 'tw-text-slate-500'],
    'secondary-icon': [
      'tw-text-slate-800',
      'tw-bg-slate-200',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-slate-800', 'tw-text-slate-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-slate-600'],
    'secondary-text': ['tw-text-slate-500'],
    'linear-gradient': ['tw-to-slate-400', 'tw-from-slate-800'],
    'light-linear-gradient': ['tw-bg-slate-400'],
    'dark-linear-gradient': ['tw-bg-slate-800'],
    'light-background': ['tw-bg-slate-50'],
    'dark-background': ['tw-bg-slate-700'],
    'tracker-dots': ['tw-border-slate-500', 'tw-bg-slate-50'],
    'active-tracker-dot': ['tw-bg-slate-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-slate-600'],
    'action-flow-button': ['tw-bg-slate-600', 'hover:tw-bg-slate-900'],
    'mobile-tracker-line': ['tw-bg-slate-500'],
    'bottom-nav-active-bar': ['tw-bg-slate-700'],
    'primary-border': ['tw-border-slate-500'],
    'dark-border': ['tw-border-slate-700'],
    'hover-background': ['hover:tw-bg-slate-50'],
    'hover-border': ['hover:tw-border-slate-500'],
    'important-badge': ['tw-bg-slate-100', 'tw-text-slate-950'],
  },
}

export default config
